import React from 'react'
import clsx from 'clsx'

// Three variants and no fourth: primary (--ink fill), secondary (1px --ink
// outline) and text (--accent, underline on hover). 52px tall on desktop,
// 56px on a phone, radius 10, Poppins 600 16, no uppercase, no
// letter-spacing.
//
// Renders an <a> when given `href`, otherwise a <button type="button">, so
// a real link stays a real link (middle-clickable, crawlable).
//
//   <Button variant="primary" href="/booking/book">Book a wash from £69</Button>
//   <Button variant="text" onClick={expand}>Have a code?</Button>
//
// Never disable the primary CTA on the booking screen (direction 8.6):
// validate on submit and send focus to the first missing field instead.
export const Button = ({ variant = 'primary', block = false, href, className, children, ...rest }) => {
  const classes = clsx('gwmc-btn', `gwmc-btn--${variant}`, block && 'gwmc-btn--block', className)

  if (href) {
    return (
      <a className={classes} href={href} {...rest}>
        {children}
      </a>
    )
  }

  return (
    <button type="button" className={classes} {...rest}>
      {children}
    </button>
  )
}
